export const LADE_AUSWAHLWERTE_SUBVENTION = "ladeAuswahlwerteSubvention";